// Module
var code = "<span class=\"edit-btn\" ng-click=\"editBooleanLogic($parent.row, $index)\">\n    <i class=\"icon-pencil pointer\" am-tooltip=\"top center to bottom center\" title=\"Edit\"></i>\n</span>\n<span class=\"bl-name\">{{$parent.row.display}}</span>\n";
// Exports
module.exports = code;